import { Directive, ElementRef, Host, inject, Input, OnInit } from '@angular/core';
import { CeParameterListComponent } from '../ce-parameter-list.component';

@Directive({
    selector: '[ceParameterLabel]',
    standalone: true,
    host: {
        class: 'u-color-text-secondary flex-middle',
        '[class.u-text-label-sm]': 'this.parent.size === "default"',
        '[class.u-text-label-xs]': 'this.parent.size === "small"',
    },
})
export class CeParameterLabelDirective implements OnInit {
    @Input() required = false;

    @Host() public parent = inject(CeParameterListComponent);
    readonly #elem = inject(ElementRef);

    ngOnInit(): void {
        if (this.required) {
            this.#elem.nativeElement.classList.add('isRequired');
        }
    }
}

@Directive({
    selector: '[ceParameterItemValue]',
    standalone: true,
    host: {
        '[class.u-text-body-md]': 'this.parent.size === "default"',
        '[class.u-text-body-sm]': 'this.parent.size === "small"',
    },
})
export class CeParameterItemValueDirective {
    @Host() public parent = inject(CeParameterListComponent);
}

@Directive({
    selector: '[ceParameterItemSecondary]',
    standalone: true,
    host: {
        '[class.u-text-body-md]': 'this.parent.size === "default"',
        '[class.u-text-body-sm]': 'this.parent.size === "small"',
    },
})
export class CeParameterItemSecondaryDirective {
    @Host() public parent = inject(CeParameterListComponent);
}
